import React from 'react';
import { motion } from 'framer-motion';
const projects = [{
  name: 'FinanceFlow',
  context: 'Mobile Banking App',
  role: 'Lead Product Manager',
  description: 'Redesigned the core money transfer experience for a highly regulated fintech environment, balancing strict KYC requirements with user friction.',
  metrics: [{
    value: '34%',
    label: 'Increase in successful transfers'
  }, {
    value: '22%',
    label: 'Reduction in compliance drop-offs'
  }, {
    value: '4.8★',
    label: 'App Store rating maintained'
  }],
  theme: 'light' as const,
  tagColor: 'bg-accent text-white',
  accentColor: 'text-accent'
}, {
  name: 'MedTrack',
  context: 'Healthcare Compliance Platform',
  role: 'Senior Product Manager',
  description: 'Led the 0-to-1 development of a HIPAA-compliant mobile application for care providers to log patient interactions securely on the go.',
  metrics: [{
    value: '10k+',
    label: 'Care providers onboarded'
  }, {
    value: '45m',
    label: 'Saved per day per user'
  }, {
    value: 'Zero',
    label: 'Compliance breaches in year one'
  }],
  theme: 'teal' as const,
  tagColor: 'bg-white/20 text-white',
  accentColor: 'text-white'
}, {
  name: 'RetailPulse',
  context: 'Consumer Insights App',
  role: 'Product Manager',
  description: 'Built a B2B mobile dashboard for retail managers to view real-time store analytics, requiring complex data visualization on small screens.',
  metrics: [{
    value: '60%',
    label: 'Increase in daily active users'
  }, {
    value: '80%',
    label: 'Reduction in report generation time'
  }, {
    value: '#1',
    label: 'Awarded "Best Internal Tool 2023"'
  }],
  theme: 'light' as const,
  tagColor: 'bg-dark text-white',
  accentColor: 'text-accent'
}];
export function CaseStudies() {
  return <section id="work" className="py-20 md:py-32 bg-primary" data-id="element-22">
      <div className="max-w-6xl mx-auto px-6" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 md:mb-24" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-serif text-text-primary mb-4" data-id="element-25">
            Selected Work
          </h2>
          <div className="h-1.5 w-20 bg-accent mb-6" aria-hidden="true" data-id="element-26" />
          <p className="text-lg text-text-secondary max-w-xl" data-id="element-27">
            Case studies demonstrating the balance of regulatory constraints and
            exceptional user experience.
          </p>
        </motion.div>

        <div className="space-y-12" data-id="element-28">
          {projects.map((project, index) => {
          const isTeal = project.theme === 'teal';
          return <motion.article key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} className={`group relative p-8 md:p-12 border ${isTeal ? 'bg-accent-secondary text-white border-accent-secondary' : 'bg-card text-text-primary border-border shadow-warm'}`} data-id="element-29">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12" data-id="element-30">
                  <div className="lg:col-span-5 flex flex-col justify-between" data-id="element-31">
                    <div data-id="element-32">
                      <div className="flex items-center space-x-3 mb-6" data-id="element-33">
                        <span className={`px-3 py-1 text-xs font-bold tracking-widest uppercase ${project.tagColor}`} data-id="element-34">
                          {project.context}
                        </span>
                      </div>
                      <h3 className="text-3xl font-serif mb-2 font-bold" data-id="element-35">
                        {project.name}
                      </h3>
                      <p className={`text-sm font-bold uppercase tracking-wider mb-6 ${isTeal ? 'text-white/60' : 'text-text-secondary'}`} data-id="element-36">
                        Role: {project.role}
                      </p>
                      <p className={`leading-relaxed ${isTeal ? 'text-white/80' : 'text-text-secondary'}`} data-id="element-37">
                        {project.description}
                      </p>
                    </div>
                  </div>

                  <div className={`lg:col-span-7 p-6 md:p-8 border ${isTeal ? 'bg-white/10 border-white/20' : 'bg-primary border-border'}`} data-id="element-38">
                    <h4 className={`text-xs font-bold uppercase tracking-widest mb-8 ${isTeal ? 'text-white/50' : 'text-text-secondary'}`} data-id="element-39">
                      Key Outcomes
                    </h4>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-8" data-id="element-40">
                      {project.metrics.map((metric, i) => <div key={i} className="flex flex-col" data-id="element-41">
                          <span className={`text-4xl md:text-5xl font-serif font-bold mb-2 ${project.accentColor}`} data-id="element-42">
                            {metric.value}
                          </span>
                          <span className={`text-sm font-medium ${isTeal ? 'text-white/70' : 'text-text-secondary'}`} data-id="element-43">
                            {metric.label}
                          </span>
                        </div>)}
                    </div>
                  </div>
                </div>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}